import { fetch as fetchApi, isString } from "./api";
import { TokenWallet, TokenWalletCodec } from "../store/tokenWallet/types";
import { flattenData, withDecoded } from "./index";
function mapToModel(data: object): TokenWallet {
  return withDecoded(TokenWalletCodec, data, decoded => ({
    ...decoded
  }));
}
export async function fetch(id: string | null | undefined, params?: {}): Promise<TokenWallet> {
  return fetchApi({
    nestedResourcePath: ["tokenwallet"],
    id,
    params
  })
    .then(response => {
      return isString(response.data) ? JSON.parse(response.data) : response.data;
    })
    .then(data => mapToModel(flattenData(data)));
}